import React, { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Paper, TextField } from '@mui/material';
import { apiRemote } from '@/api/wp-api';
import AllCourses from './components/AllCourses';
import { useAlert } from "@/contexts/AlertContext";
import img_course from '../../images/imgcourse.png';

// Thêm interface để định nghĩa kiểu dữ liệu từ API
interface ICourse {
    id: number;
    coursename: string;
    summary: string;
    view_url: string;
    course_image: string;
    last_access_time: string;
    total_activity: number;
    total_activity_completion: number;
    completionPercentage: number;
    isEnrolled?: boolean; // thêm trường này để phân biệt khóa học đã đăng ký
}

interface ICourseResponse {
    count: number;
    data: ICourse[];
}


const CourseStatistic = () => {
    const [loading, setLoading] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const alert = useAlert();

    const loadData = async () => {
        setLoading(true);
        try {
            const [courseResponse] = await Promise.all([
                apiRemote.getMyCourse('0', '0'),
            ]);
            console.log("courseResponse", courseResponse.data);

            const allCoursesData = courseResponse.data.course_details.map((course: ICourse) => ({
                id: course.id.toString(),
                title: course.coursename,
                completedActivities: course.total_activity_completion || 0,
                totalActivities: course.total_activity || 0,
                completionPercentage: course.completionPercentage || 0,
                lastAccess: course.last_access_time || 'N/A',
                description: course.summary,
                imageUrl: course.course_image || img_course,
                isEnrolled: !!course.last_access_time
            }));

            setAllCourses(allCoursesData);
        } catch (error) {
            // alert.error('Error loading data');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleReload = useCallback(() => {
        loadData();
    }, []);

    return (
        <Box
            sx={{
                p: 3,
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                flex: 1,
            }}
        >
            <AllCourses 
                courses={allCourses} 
                loading={loading} 
                onReload={handleReload}
            />
        </Box>
        // <Paper sx={{ mb: 3, p: 2 }}>
        //     <Typography
        //         variant="h5"
        //         sx={{
        //             mb: 2,
        //             color: '#0A3161', // Màu xanh đậm cho tiêu đề
        //             fontSize: '20px',
        //             fontWeight: 600
        //         }}
        //     >
        //         Course Statistics
        //     </Typography>
        //     <AllCourses courses={allCourses} loading={loading} />
        // </Paper>
    );
};

export default CourseStatistic;